module.exports = __webpack_public_path__ + "img/lock.682d44f8.png";